import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { N100 } from '@atlaskit/theme/colors';
import { gridSize } from '@atlaskit/theme/constants';
var ThemeColor = {
    text: N100,
};
var Separator = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  flex-shrink: 0;\n  padding: 0 ", "px;\n  text-align: center;\n  width: ", "px;\n"], ["\n  color: ", ";\n  flex-shrink: 0;\n  padding: 0 ", "px;\n  text-align: center;\n  width: ", "px;\n"])), ThemeColor.text, gridSize, gridSize);
Separator.displayName = 'Separator';
export default Separator;
var templateObject_1;
//# sourceMappingURL=Separator.js.map